import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export function toCamelCase(str: string): string {
	return str.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
}

export function toKebabCase(str: string): string {
	return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

/**
 * Custom hook to find the index.ts of the current path in a list of paths.
 *
 * @param {string[]} paths - Array of paths to match against the current location.
 * @returns {number | undefined} - The index.ts of the matched path or undefined if no match is found.
 */

export function usePathMatchIndex(paths: string[]): number | undefined {
	const location = useLocation();

	return useMemo(() => {
		const pathname = location.pathname.split('/').pop();

		for (let i = 0; i < paths.length; i++) {
			const normalizedPath = toKebabCase(paths[i].replace(/\/$/, ''));

			if (
				pathname === normalizedPath ||
				pathname?.startsWith(normalizedPath + '/') ||
				location.pathname.includes(normalizedPath)
			) {
				return i;
			}
		}

		return undefined;
	}, [location.pathname, paths]);
}
